module.exports = __webpack_public_path__ + "img/cooperate_jr_04@2x.7ca71012.png";